<template>
  <div class="language-textarea">
    <LanguageRadioButtons :value="lang" class="language-textarea-lang" @input="handleLangChange" />
    <el-input :value="currentText" :type="type" :rows="rows" :placeholder="placeholder" :maxlength="maxlength" :show-word-limit="showWordLimit" @input="handleTextInput" />
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import { computed } from 'vue'
import LanguageRadioButtons from '@/components/LanguageRadioButtons'

const props = defineProps({
  value: {
    type: Object,
    default: () => ({}),
  },
  lang: {
    type: [String, Number],
    default: '',
  },

  type: {
    type: String,
    default: 'textarea',
  },
  rows: {
    type: [String, Number],
    default: 6,
  },
  placeholder: {
    type: String,
    default: '',
  },
  maxlength: {
    type: [String, Number],
    default: undefined,
  },
  showWordLimit: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['input', 'update:lang'])

const currentText = computed({
  get() {
    if (!props.value || typeof props.value !== 'object') return ''
    const key = props.lang
    return props.value[key] == null ? '' : props.value[key]
  },
  set(next) {
    const obj = { ...(props.value || {}) }
    obj[props.lang] = next
    emit('input', obj)
  },
})

function handleTextInput(val) {
  currentText.value = val
}

function handleLangChange(val) {
  emit('update:lang', val)
}
/* eslint-enable no-unused-vars */
/* eslint-enable no-undef */
</script>

<style lang="scss" scoped>
.language-textarea {
  width: 100%;
}

.language-textarea-lang {
  margin-bottom: 10px;
}
</style>
